import { pathJoin } from 'src/reducers/routing/utils'

export const createEditRouteMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
})
